import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import PagamentoRealizado from "../../../assets/kinologyIcons/svg/pagamento_realizado.svg";
import PagamentoRealizadoAmpulheta from "../../../assets/kinologyIcons/svg/pagamentoAmpulheta.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { ConfigsActions } from "../../../store/ducks/configs";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalPagamentoProcessado: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);

	const modalVisible = useSelector(
		(state: any) => state.financial.modal_pagamento_processado
	);
	const modalType: 'paymentPromess' | 'pixPayment' | 'userInWhitList' =  useSelector((state: any) => state.financial.modal_payment_process_type);

	const inadimplencia_motivo = useSelector((state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO)

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_pagamento_processado(false));
	};

	useEffect(()=>{
		if( modalVisible && modalType == 'pixPayment'){
			dispatch(ConfigsActions.config_request());
		}
	},[modalVisible, modalType])

	useEffect(()=>{
		if(!inadimplencia_motivo){
			dispatch(FinancialActions.set_modal_pagamento_processado(false))
		}
		
	},[inadimplencia_motivo])

	const Subtitile = {
		pixPayment:current_language?.aguardar_processamento,
		userInWhitList: current_language?.pagamento_processado_descricao,
		paymentPromess: current_language?.acesso_liberado_pagamento_aprovado
	};

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modalVisible}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={modalVisible}>
				<ModalContainer>
					<ModalContent>
						<IconContainer>
							<img
								style={{ width: "4rem", height: "4rem" }}
								src={modalType == 'pixPayment' ? PagamentoRealizadoAmpulheta : PagamentoRealizado}
							/>
						</IconContainer>
						<Title>{current_language?.pagamento_sendo_processado}</Title>
						<InfoText>
							{Subtitile[modalType]}
						</InfoText>
						<Button 
							onClick={handleClose}
							style={{display: modalType == 'userInWhitList' ? 'flex' : 'none'}}
						>
							{current_language?.entendi}
						</Button>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const IconContainer = styled.div`
	margin-bottom: 16px;
	margin-top: 16px;
`;

const Title = styled.h2`
	font-size: 18px;
	color: #002060;
	margin: 0 0 8px;
`;

interface ButtonProps {
	primary?: boolean;
}

const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	color: white;
	background-color: ${({ primary }) => (primary ? "white" : "#009973")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #009973")};
	color: ${({ primary }) => (primary ? "#009973" : "white")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ primary }) => (primary ? "#009973" : "#f6f6f6")};
		color: ${({ primary }) => (primary ? "#009973" : "#009973")};
	}
`;

const InfoText = styled.p`
	font-size: 14px;
	color: #000E4B;
	margin: 0 0 16px;
`;

export default ModalPagamentoProcessado;
